import { SecureStorage } from '@aparajita/capacitor-secure-storage';

const DEVICE_ID_KEY = 'si_device_id';

/**
 * Guest accounts are keyed by this id, so it works like a password: a random
 * UUID kept in the iOS Keychain / Android Keystore, never identifierForVendor
 * (which changes on reinstall and would lose the guest's progress).
 */
const getDeviceId = async (): Promise<string> => {
  const stored = await SecureStorage.get(DEVICE_ID_KEY);

  if (typeof stored === 'string' && stored) return stored;

  const deviceId = crypto.randomUUID();
  await SecureStorage.set(DEVICE_ID_KEY, deviceId);

  return deviceId;
};

export { getDeviceId };
